import api from ".";


export default {
    getUserBooking: async () => {
        const response = await api.get(`/api/booking/phone`);
        return response.data;
    },
    getBookingByPeriod: async (from, to) => {
        const response = await api.get(`/api/booking/period`, { params: { from, to } });
        return response.data;
    },
    changeBookingTime: async (id, time) => {
        const response = await api.put(`/api/booking/${id}`, { time });
        return response.status === 201 ? true : false;
    },
    changeBooking: async (id, data) => {
        const response = await api.put(`/api/booking/${id}/full`, data);
        return response.status === 201 ? true : false;
    },
    deleteBooking: async (id) => {
        const response = await api.delete(`/api/booking/${id}`);
        return response.status === 200 ? true : false;
    },
    createBooking: async (data) => {
        const response = await api.post(`/api/booking/create`, data);
        return response.status === 201 ? true : false;
    }
}